import { AxiosError, AxiosResponse } from 'axios';
import instance, { ApiError } from '../../api/instance';
import { UploadFileToBucket } from 'src/api/utils/uploadFileToBucket';
import { DeviceGroupVideo } from 'src/features/deviceGroupVideos/deviceGroupVideos.types';

const deviceGroupVideosApiPath = (groupId: string) => `/device_groups/${groupId}/videos`;

export const getDeviceGroupVideosAPI = async ({
  groupId,
}: {
  groupId: string;
}): Promise<AxiosResponse<DeviceGroupVideo[] & ApiError>> => {
  return instance
    .get<DeviceGroupVideo[]>(deviceGroupVideosApiPath(groupId))
    .catch(e => e.response as AxiosError<ApiError> as never);
};

export type GroupVideo = Pick<DeviceGroupVideo, 'name'>;

export const createDeviceGroupVideoAPI = async ({
  groupId,
  data,
}: {
  groupId: string;
  data: GroupVideo;
}): Promise<AxiosResponse<DeviceGroupVideo & ApiError>> => {
  return instance
    .post<DeviceGroupVideo>(deviceGroupVideosApiPath(groupId), data)
    .catch(e => e.response as AxiosError<ApiError> as never);
};

const deviceGroupVideoApiPath = (companyId: string, videoId: string) => `/device_groups/${companyId}/videos/${videoId}`;

export const fetchDeviceGroupVideoAPI = async ({
  groupId,
  videoId,
}: {
  groupId: string;
  videoId: string;
}): Promise<AxiosResponse<DeviceGroupVideo & ApiError>> => {
  return instance
    .get<DeviceGroupVideo>(deviceGroupVideoApiPath(groupId, videoId))
    .catch(e => e.response as AxiosError<ApiError> as never);
};
export const updateDeviceGroupVideoAPI = async ({
  groupId,
  videoId,
  data,
}: {
  groupId: string;
  videoId: string;
  data: Partial<Omit<DeviceGroupVideo, 'id'>>;
}): Promise<AxiosResponse<DeviceGroupVideo & ApiError>> => {
  return instance
    .post<DeviceGroupVideo>(deviceGroupVideoApiPath(groupId, videoId), data)
    .catch(e => e.response as AxiosError<ApiError> as never);
};

export const deleteDeviceGroupVideoAPI = async ({
  groupId,
  videoId,
}: {
  groupId: string;
  videoId: string;
}): Promise<AxiosResponse<void & ApiError>> => {
  return instance
    .delete(deviceGroupVideoApiPath(groupId, videoId))
    .catch(e => e.response as AxiosError<ApiError> as never);
};

export type UploadVideoImage = (params: {
  groupId: string;
  videoId: string;
  data: { filename: string };
}) => Promise<AxiosResponse<Parameters<UploadFileToBucket>[0]>>;

const deviceGroupVideoImageApiPath = (companyId: string, bannerId: string) =>
  `/device_groups/${companyId}/videos/${bannerId}/images/upload`;

export const uploadDeviceGroupVideoImage: UploadVideoImage = async ({ groupId, videoId, data }) => {
  return instance.post(deviceGroupVideoImageApiPath(groupId, videoId), data).catch(e => e.response as never);
};
